import React from 'react'
import type { SvgIconProps } from '@material-ui/core/SvgIcon'
import SvgIcon from '@material-ui/core/SvgIcon'

const DescriptionIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 14 14" {...props}>
    <path d="M2 14C0.896875 14 0 13.1031 0 12V2C0 0.896875 0.896875 0 2 0H12C13.1031 0 14 0.896875 14 2V8.67188C14 9.20312 13.7906 9.7125 13.4156 10.0875L10.0844 13.4156C9.70938 13.7906 9.2 14 8.66875 14H2ZM12.1719 8.5H9.25C8.83438 8.5 8.5 8.83438 8.5 9.25V12.1719L12.1719 8.5Z" />
  </SvgIcon>
)
export default DescriptionIcon
